// import { CommonModule } from '@angular/common';
// import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
// import { AppSwal } from '../../../Services/alertService';
// import { FormsModule } from '@angular/forms';
// import { ApiCallService } from '../../../Services/ApiCallService';
// import { Router } from '@angular/router';
// export interface EnquiryPackage {
//   Name: string;
//   Email: string;
//   Phone: string;
//   Plan: string;
//   Location: string;
//   Message?: string;
//   consent: boolean;
// }
// @Component({
//   selector: 'app-package-enquire',
//   standalone: true,
//   imports: [CommonModule, FormsModule],
//   templateUrl: './package-enquire.html',
//   styleUrl: './package-enquire.css',
//   host: { 'ngSkipHydration': 'true' }
// })
// export class PackageEnquire implements OnInit {
//   ngOnInit(): void {
//     this.changePlan();
//   }
//   constructor(private cdr: ChangeDetectorRef, private api: ApiCallService, private router: Router) { }
//   selectedPlan: string = '';
//   changePlan(): void {
//     this.formData.Plan = 'null';
//     this.cdr.detectChanges();
//   }
//   formData: EnquiryPackage = {
//     Name: '',
//     Email: '',
//     Phone: '',
//     Plan: '',
//     Location: '',
//     Message: '',
//     consent: false
//   };
//   validatePackageForm(): boolean {
//     console.log('Validating Form:', this.formData);
//     if (!this.formData.Name || this.formData.Name.trim().length < 2) {
//       AppSwal.fire('Empty Field', 'Name is required and must be at least 2 characters', 'info');
//       return false;
//     }
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!this.formData.Email || !emailRegex.test(this.formData.Email)) {
//       AppSwal.fire('Empty Field', 'A valid email is required', 'info');
//       console.error('Valid email is required', this.formData.Email);
//       return false;
//     }
//     const phoneRegex = /^[6-9]\d{9}$/;
//     if (!this.formData.Phone || !phoneRegex.test(this.formData.Phone)) {
//       AppSwal.fire('Phone', 'A valid 10-digit phone number is required', 'info');
//       console.error('Invalid phone number:', this.formData.Phone);
//       return false;
//     }
//     if (this.formData.Plan === 'null' || this.formData.Plan.trim().length === 0) {
//       AppSwal.fire('Empty Field', 'Plan selection is required', 'info');
//       console.error('Plan selection is required');
//       return false;
//     }
//     if (!this.formData.Location || this.formData.Location.trim().length === 0) {
//       AppSwal.fire('Empty Field', 'Location is required', 'info');
//       console.error('Location is required');
//       return false;
//     }
//     if (!this.formData.consent) {
//       AppSwal.fire('Empty Field', 'consent selection is required', 'info');
//       console.error('consent selection is required');
//       return false;
//     }
//     return true;
//   }
//   submitEnquiryForm(): void {
//     console.log("Button clicked, submitEnquiryForm started"); // Add this debug line
//     if (!this.validatePackageForm()) {
//       return;
//     }
//     const otpPayload = {
//       clientEmail: this.formData.Email
//     };
//     const mailPayload = {
//       name: this.formData.Name,
//       clientEmail: this.formData.Email,
//       phone: this.formData.Phone,
//       message: this.formData.Message,
//       plan: this.formData.Plan,
//       title: 'RedMonk Wellness Packages'
//     };
//     const leadPayload = {
//       LeadName: this.formData.Name,
//       LeadEmail: this.formData.Email,
//       Query: this.formData.Message || 'Package enquiry for ' + this.formData.Plan,
//       Gender: '',
//       Address: this.formData.Location,
//       City: this.formData.Location,
//       ContactInfo: this.formData.Phone,
//       Source: 'Website',
//       FormType: this.formData.Plan,
//       CreatedBy: 1,
//       Age: 0,
//       CreatedByRole: '',
//       AssignedToID: 0,
//       AssignedToRole: '',
//       FormConsent: this.formData.consent
//     };
//     console.log("it is working till now before send otp");
//     AppSwal.fire({
//       title: 'Please wait...',
//       text: 'Sending Verification Code to your email...',
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       didOpen: () => AppSwal.showLoading()
//     });
//     this.api.postData('Notification', 'SendEmailOtp', otpPayload).subscribe({
//       next: (res: any) => {
//         AppSwal.close(); // Close loader after API response
//         console.log('Send Verification Code Response:', res); // Add this to debug
//         if (!res?.success) {
//           AppSwal.fire('Failed', 'Unable to send Verification Code. Please try again.', 'error');
//           return;
//         }
//         AppSwal.fire({
//           title: 'Code Verification',
//           text: 'Please enter the Verification Code sent to your email',
//           input: 'text',
//           inputPlaceholder: 'Enter 6-digit Verification Code',
//           inputAttributes: {
//             maxlength: '6',
//             inputmode: 'numeric',
//             autocomplete: 'one-time-code',
//             autocapitalize: 'off',
//             autocorrect: 'off'
//           },
//           allowOutsideClick: false,
//           allowEscapeKey: false,
//           showCancelButton: true,
//           confirmButtonText: 'Verify Your Code',
//           cancelButtonText: 'Cancel',
//           focusConfirm: false,
//           preConfirm: (otp) => {
//             if (!otp) {
//               AppSwal.showValidationMessage('Verification Code is required');
//               return false;
//             }
//             if (!/^[0-9]{6}$/.test(otp)) {
//               AppSwal.showValidationMessage('Verification Code must be a 6-digit number');
//               return false;
//             }
//             return otp;
//           }
//         }).then(result => {
//           if (!result.isConfirmed) return;

//           const verifyPayload = {
//             otp: result.value,
//             email: this.formData.Email
//           };
//           console.log("before Verification Code verification");          // STEP 6: Verify OTP (loader)
//           AppSwal.fire({
//             title: 'Verifying',
//             text: 'Please wait...',
//             allowOutsideClick: false,
//             allowEscapeKey: false,
//             didOpen: () => AppSwal.showLoading()
//           });
//           this.api.postData('Notification', 'VerifyOtp', verifyPayload).subscribe({
//             next: (verifyRes: any) => {
//               console.log('Verify Verification Code Response: ', verifyRes);
//               AppSwal.close();              // Fix: Check if verification was successful              // Check both success and status properties
//               if (verifyRes?.success !== true && verifyRes?.status !== true) {
//                 AppSwal.fire('Invalid Verification Code', 'The Verification Code you entered is incorrect.', 'error');
//                 return;
//               }
//               console.log("after verification");              // STEP 7: OTP verified → send enquiry (loader)
//               AppSwal.fire({
//                 title: 'Processing',
//                 text: 'Submitting your package enquiry...',
//                 allowOutsideClick: false,
//                 allowEscapeKey: false,
//                 didOpen: () => AppSwal.showLoading()
//               });
//               console.log("Verification Code verification successful, submitting enquiry");              // Call both APIs simultaneously
//               const leadRegistration = this.api.postData('UserRoles', 'RegisterLeads', leadPayload).toPromise();
//               const sendEmail = this.api.postData('Notification', 'PlanEnquiry', mailPayload).toPromise();
//               Promise.all([leadRegistration, sendEmail])
//                 .then(([leadRes, mailRes]: [any, any]) => {
//                   AppSwal.close();
//                   console.log('Lead Registration Response:', leadRes);
//                   console.log('Email Response:', mailRes);                  // Fix: Check if at least one API succeeded
//                   const isLeadSuccess = leadRes?.success === true || leadRes?.status === true;
//                   const isMailSuccess = mailRes?.success === true || mailRes?.status === true;
//                   if (isLeadSuccess || isMailSuccess) {
//                     AppSwal.fire(
//                       'Success',
//                       'Your package enquiry has been submitted successfully!',
//                       'success'
//                     ).then(() => {
//                       this.formData = {
//                         Name: '',
//                         Email: '',
//                         Phone: '',
//                         Plan: '',
//                         Location: '',
//                         Message: '',
//                         consent: false
//                       };
//                       this.router.navigateByUrl('/PackageThankyou');
//                     });
//                   } else {
//                     AppSwal.fire(
//                       'Failed',
//                       'Unable to submit your package enquiry. Please try again.',
//                       'error'
//                     );
//                   }
//                 })
//                 .catch((error) => {
//                   AppSwal.close();
//                   console.error('Error in parallel operations:', error);
//                   AppSwal.fire(
//                     'Error',
//                     'Something went wrong while submitting your enquiry.',
//                     'error'
//                   );
//                 });
//             },
//             error: (error) => {
//               AppSwal.close();
//               console.error('Verification Code Verification Error:', error);
//               AppSwal.fire(
//                 'Error',
//                 'Verification Code verification failed. Please try again.',
//                 'error'
//               );
//             }
//           });
//         });
//       },
//       error: (error) => {
//         AppSwal.close();
//         console.error('Send Verification Code Error:', error);
//         AppSwal.fire(
//           'Error',
//           'Unable to initiate Verification Code verification. Please try again.',
//           'error'
//         );
//       }
//     });
//   }
// }

import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AppSwal } from '../../../Services/alertService';
import { FormsModule } from '@angular/forms';
import { ApiCallService } from '../../../Services/ApiCallService';
import { Router } from '@angular/router';

export interface EnquiryPackage {
  Name: string;
  Email: string;
  Phone: string;
  Plan: string;
  Location: string;
  CityID: number | null;
  Message?: string;
  consent: boolean;
}

@Component({
  selector: 'app-package-enquire',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './package-enquire.html',
  styleUrl: './package-enquire.css',
  host: { 'ngSkipHydration': 'true' }
})
export class PackageEnquire implements OnInit {
  ngOnInit(): void {
    this.changePlan();
  }

  constructor(private cdr: ChangeDetectorRef, private api: ApiCallService, private router: Router) { }

  selectedPlan: string = '';

  changePlan(): void {
    this.formData.Plan = 'null';
    this.cdr.detectChanges();
  }

  formData: EnquiryPackage = {
    Name: '',
    Email: '',
    Phone: '',
    Plan: '',
    Location: '',
    CityID: null,
    Message: '',
    consent: false
  };

  cities = [
    { CityID: 1, CityName: 'Mumbai' },
    { CityID: 2, CityName: 'Kolkata' },
  ];

  validatePackageForm(): boolean {
    // Name
    if (!this.formData.Name || this.formData.Name.trim().length < 2) {
      AppSwal.fire('Empty Field', 'Name is required and must be at least 2 characters', 'info');
      return false;
    }

    // Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!this.formData.Email || !emailRegex.test(this.formData.Email)) {
      AppSwal.fire('Empty Field', 'A valid email is required', 'info');
      return false;
    }

    // Phone
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!this.formData.Phone || !phoneRegex.test(this.formData.Phone)) {
      AppSwal.fire('Phone', 'A valid 10-digit phone number is required', 'info');
      return false;
    }

    // Plan
    if (this.formData.Plan === 'null' || this.formData.Plan.trim().length === 0) {
      AppSwal.fire('Empty Field', 'Plan selection is required', 'info');
      return false;
    }

    // City
    if (!this.formData.CityID) {
      AppSwal.fire('Empty Field', 'City is required', 'info');
      return false;
    }

    // consent validation
    if (!this.formData.consent) {
      AppSwal.fire('Empty Field', 'consent selection is required', 'info');
      return false;
    }

    return true;
  }

  submitEnquiryForm(): void {
    // STEP 1: Client-side validation
    if (!this.validatePackageForm()) {
      return;
    }

    const selectedCity = this.cities.find((c) => c.CityID === this.formData.CityID);
    this.formData.Location = selectedCity ? selectedCity.CityName : '';

    // STEP 2: Prepare payloads (single source of truth)
    const otpPayload = {
      clientEmail: this.formData.Email
    };

    // Matches Patient API InsertEnquiryDetails(Email, Name, MobileNo, City, Interest, Message, PlanType)
    // Interest is left blank here - this form always submits a PlanType instead.
    const mailPayload = {
      Name: this.formData.Name,
      Email: this.formData.Email,
      MobileNo: this.formData.Phone,
      City: this.formData.Location,
      Interest: '',
      Message: this.formData.Message,
      PlanType: this.formData.Plan
    };

    // Lead registration commented out to avoid inserting into CRM (same as bookconsultation.ts)
    // const leadPayload = {
    //   LeadName: this.formData.Name,
    //   LeadEmail: this.formData.Email,
    //   Query: this.formData.Message || 'Package enquiry for ' + this.formData.Plan,
    //   Gender: '',
    //   Address: this.formData.Location,
    //   City: this.formData.Location,
    //   ContactInfo: this.formData.Phone,
    //   Source: 'Website',
    //   FormType: this.formData.Plan,
    //   CreatedBy: 1,
    //   Age: 0,
    //   CreatedByRole: '',
    //   AssignedToID: 0,
    //   AssignedToRole: '',
    //   FormConsent: this.formData.consent
    // };

    // STEP 3: Show loader before sending OTP
    AppSwal.fire({
      title: 'Please wait...',
      text: 'Sending Verification Code to your email...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => AppSwal.showLoading()
    });

    // STEP 4: Send OTP (Patient API - 'User' controller, same as bookconsultation.ts)
    this.api.postData('User', 'SendEmailOtp', otpPayload).subscribe({
      next: (res: any) => {
        AppSwal.close();

        if (!res?.success) {
          AppSwal.fire('Failed', 'Unable to send Verification Code. Please try again.', 'error');
          return;
        }

        // STEP 5: OTP input popup
        AppSwal.fire({
          title: 'Code Verification',
          text: 'Please enter the Verification Code sent to your email',
          input: 'text',
          inputPlaceholder: 'Enter 6-digit Verification Code',
          inputAttributes: {
            maxlength: '6',
            inputmode: 'numeric',
            autocomplete: 'one-time-code',
            autocapitalize: 'off',
            autocorrect: 'off'
          },
            customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-secondary',
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: true,
          confirmButtonText: 'Verify Your Code',
          cancelButtonText: 'Cancel',
          focusConfirm: false,
          preConfirm: (otp) => {
            if (!otp) {
              AppSwal.showValidationMessage('Verification Code is required');
              return false;
            }
            if (!/^[0-9]{6}$/.test(otp)) {
              AppSwal.showValidationMessage('Verification Code must be a 6-digit number');
              return false;
            }
            return otp;
          }
        }).then(result => {
          if (!result.isConfirmed) return;

          const verifyPayload = {
            otp: result.value,
            email: this.formData.Email
          };

          // STEP 6: Verify OTP (loader)
          AppSwal.fire({
            title: 'Verifying',
            text: 'Please wait...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => AppSwal.showLoading()
          });

          this.api.postData('User', 'VerifyOtp', verifyPayload).subscribe({
            next: (verifyRes: any) => {
              AppSwal.close();

              if (verifyRes?.success !== true && verifyRes?.status !== true) {
                AppSwal.fire('Invalid Verification Code', 'The Verification Code you entered is incorrect.', 'error');
                return;
              }

              // STEP 7: OTP verified -> submit enquiry (DB insert + plan email handled server-side)
              AppSwal.fire({
                title: 'Processing',
                text: 'Submitting your package enquiry...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => AppSwal.showLoading()
              });

              // commenting the register lead API call to avoid inserting lead in CRM
              // const leadRegistration = this.api.postData('UserRoles', 'RegisterLeads', leadPayload).toPromise();

              this.api.postData('User', 'InsertEnquiryDetails', mailPayload).subscribe({
                next: (enquiryRes: any) => {
                  AppSwal.close();

                  if (enquiryRes?.success) {
                    AppSwal.fire(
                      'Success',
                      'Your package enquiry has been submitted successfully!',
                      'success'
                    ).then(() => {
                      this.formData = {
                        Name: '',
                        Email: '',
                        Phone: '',
                        Plan: '',
                        Location: '',
                        CityID: null,
                        Message: '',
                        consent: false
                      };
                      this.router.navigateByUrl('/PackageThankyou');
                    });
                  } else {
                    AppSwal.fire(
                      'Failed',
                      enquiryRes?.message || 'Unable to submit your package enquiry. Please try again.',
                      'error'
                    );
                  }
                },
                error: () => {
                  AppSwal.close();
                  AppSwal.fire(
                    'Error',
                    'Something went wrong while submitting your enquiry.',
                    'error'
                  );
                }
              });
            },
            error: () => {
              AppSwal.close();
              AppSwal.fire(
                'Error',
                'Verification Code verification failed. Please try again.',
                'error'
              );
            }
          });
        });
      },
      error: () => {
        AppSwal.close();
        AppSwal.fire(
          'Error',
          'Unable to initiate Verification Code verification. Please try again.',
          'error'
        );
      }
    });
  }
}